import React from 'react';
import { Chip } from "@material-ui/core";


/**
 * Mapping des statuts de bus vers leurs composants visuels
 * 
 * Chaque statut est associé à un Chip Material-UI avec :
 * - Couleur et style spécifiques
 * - Label en français
 * - Classes CSS personnalisées pour les couleurs de fond
 */
const statusLabel: Record<CRM.BusStatus, React.ReactElement> = {
  "ready": (
    <Chip
      size="medium"
      label="PRET"
      color="secondary"
      className={'bold bgGreen'}
      style={{fontSize: '0.6rem'}}
    />
  ),
  "in-rotation": (
    <Chip
      size="medium"
      label="EN ROTATION"
      color="secondary"
      className={'bold bgOrange'}
      style={{fontSize: '0.6rem'}}
    />
  ),
  "deposit": (
    <Chip
      size="medium"
      label="EN DEPOT"
      color="secondary"
      className={'bold bgRed'}
      style={{fontSize: '0.6rem'}}
    />
  )
}

/**
 * Composant d'affichage du statut d'un bus
 * 
 * Ce composant affiche visuellement le statut d'un bus avec :
 * - Chip coloré selon le statut
 * - Labels en français (PRET, EN ROTATION, EN DEPOT)
 * - Couleurs de fond personnalisées (vert, orange, rouge)
 * - Taille de police réduite pour l'intégration
 * 
 * Logique métier :
 * - Mapping direct du statut vers le composant visuel
 * - Support des trois statuts : ready, in-rotation, deposit
 * - Interface cohérente avec le design system
 * 
 * @param _status Statut du bus à afficher
 * @returns Composant React du statut du bus
 */
export function BusStatusLabel(_status: CRM.BusStatus) {
  return statusLabel[_status];
}